import React from "react";
import dynamic from "next/dynamic";
// import { useDispatch } from "react-redux";

// import { twoStepNewCarQuote } from "@analytics/newCar/actions/landing";

const VehicleDetailsComponent = dynamic<any>(() => import("./vehicleDetails"), {
  ssr: true
});

const VehicleDetails = props => {
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(twoStepNewCarQuote({}));
  // }, []);

  // const Component = isDesktop ? DesktopVehicleDetails : MobileVehicleDetails;
  // return <Component {...props} />;

  return <VehicleDetailsComponent {...props} />;
};

export default VehicleDetails;
